const columns = [
  {
    title: "企业名称",
    key: "dept_full_cname",
  },
  {
    title: "企业简称",
    key: "dept_cn_name",
  },
  {
    title: "企业类型",
    key: "dept_type",
    width: 150,
  },
  {
    title: "企业代码",
    key: "dept_code",
    width: 300,
  },
  {
    title: "企业联系方式",
    key: "dept_contcat",
    width: 300,
  },
  {
    title: "权限配置",
    slot: "iconfontconfig",
    width: 100,
    iconClassConfig: [
      { name: "ys-iconshezhi", code: 0, status: 1, Pname: "ent_per_config" }, // 配置
    ],
  },
  {
    title: "操作",
    slot: "iconfont",
    width: 250,
    iconClass: [
      { name: "ys-iconbianji", code: 1, status: 1, Pname: "ent_edit" }, // 编辑
      {
        name: "ys-iconlajitongbeifen",
        code: -1,
        status: 1,
        Pname: "ent_delete",
      }, // 删除
    ],
  },
];

export default columns;
